import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import Settle from '@/components/Settle'

Vue.use(Router)

export default new Router({
    mode: 'history',
    base: '/web/',
    scrollBehavior(to, from, savedPosition) {
        return { x: 0, y: 0 }
    },
    routes: [{
        path: '/',
        name: '海渡学院',
        component: Index
    }, {
        path: '/settle',
        name: '老师/机构入驻',
        component: Settle
    }]
})


// WEBPACK FOOTER //
// ./src/router/index.js